"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Button_1 = require("./Button");
var Google_1 = require("../atoms/icons/svg/Google");
var icon = React.createElement(Google_1.default, { size: 20 });
var ButtonGoogle = function (_a) {
    var disabled = _a.disabled, onClick = _a.onClick, onlyIcon = _a.onlyIcon, size = _a.size, text = _a.text;
    return (React.createElement(Button_1.Button, { ghost: true, disabled: disabled, color: "#DD4B39", size: size, icon: icon, style: { width: '100%' }, onClick: onClick }, !onlyIcon && (text || 'Google')));
};
exports.default = ButtonGoogle;
//# sourceMappingURL=ButtonGoogle.js.map